import { useState } from 'react';

import { Button } from 'components/button';

import { AsyncButtonProps } from './types';

export const AsyncButton = ({
  onClick,
  disabled,
  ...props
}: AsyncButtonProps) => {
  const [inProgress, setInProgress] = useState(false);
  return (
    <Button
      disabled={disabled || inProgress}
      onClick={async (e) => {
        setInProgress(true);
        await onClick(e);
        setInProgress(false);
      }}
      {...props}
    />
  );
};
